import { WebView } from '@zenbusiness/application-commons-webview';

import { RELEASE_DISABLE_WIRE_TRANSACTION_TYPE_IN_ZB_APP } from '#client/constants/experimentsFlags';
import useFeatureFlag from '#client/hooks/useFeatureFlag';

export const useDisableWireInZBApp = () => {
  const { isWebView } = WebView;
  const [isDisableWireOnWebviewFlagEnabled, isDisableWireOnWebviewLoading] = useFeatureFlag(
    RELEASE_DISABLE_WIRE_TRANSACTION_TYPE_IN_ZB_APP
  );

  return {
    isDisable: isWebView && isDisableWireOnWebviewFlagEnabled && !isDisableWireOnWebviewLoading
  };
};
